import { IEventPayload } from './BlockEvent'

export const memoryGameStartedEvent = "block.memory.game-started"

export const memoryGameCompletedEvent = "block.memory.game-completed"

export interface IMemoryGameCompletedEventPayload extends IEventPayload{
    /**
     * @member numberOfInteractions The number of attempts to find pairs
     */
    numberOfInteractions: number
    /**
     * @member consumedTime The time taken by user to complete the game in milliseconds. Return null when timer feature disabled
     */
    consumedTime: number | null
    /**
     * @member score The score that user got for the game. Return null when stars feature disabled
     */
    score: number | null
    /**
     * @member maxScore The maximum score user can get for the game. Return null when stars feature disabled
     */
    maxScore: number | null
    /**
     * @member nickname The nickname of user that was entered before start game. Return null when ratings feature disabled
     */
    nickname: string | null
}